import React from 'react'
import ScoringLeadersHomeNavigation from './ScoringLeadersHomeNavigation'
import SelectLeagueForScoringLeaders from '../UIElements/SelectLeagueForScoringLeaders'
import Footer from '../UIElements/Footer'
import Banner from './Banner'
import './StatsAndStandingsHome.css'

const ScoringLeadersHome = () => {
	return (
		<div>
			{/* StatsAndStandingsHomeNavigation contains HomeHeader (just says Stats & Standings)
			and the HomeNavLinks (which is the ADMIN button on the far right) */}
			<ScoringLeadersHomeNavigation />
			<Banner />
			<SelectLeagueForScoringLeaders />
			{/* <div className='rem'>
				<Footer />
			</div> */}
		</div>
	)
}

export default ScoringLeadersHome
